import { render } from "@wordpress/element";
import App from "./App";

render(<App />, document.getElementById("wpqt-app"));
